const routesPath = {
  base: "/",
  getStarted: "get-started",
  otpVerification: "otp-verification",
  editEmail: "edit-email",
  profileInformation: "profile-information",
  dependents: "dependents",
  benefits: "benefits",
  documents: "documents",
  payments: "payments",
  confirmation: "confirmation",
  cardDetails: "card-details",
  applicationSuccessful: "application-successful",
  mfa: "mfa",
  challenge: "challenge",
  account: "account",
  forgotUsername: "forgotUsername",
  forgotPassword: "forgotPassword",
  pAndALoginSuccess: "pAndALoginSuccess",
  resetPassword: "resetPassword",
  participantOTP: "participant-otp",
  participantEmail: "participant-email",
  enrollments: "enrollments",
};

export default routesPath;
